//货物表格新建、编辑弹窗
<template>
  <el-dialog
    v-if="dialogVisible"
    :visible.sync="dialogVisible"
    :title="getTitle"
    width="80%"
    append-to-body
  >
    <div class="dialog-content">
      <el-form :model="dialogData" :rules="rules" ref="dialogForm">
        <el-row :gutter="24">
          <el-col :span="6">
            <el-form-item label="商品名称" prop="productParentName" label-width="120px">
              <search-table
                :value="dialogData.productParentName"
                searchType="product"
                :isMultiple="true"
                :currentValue="dialogData.productParentName"
                :extraData="{
                  adminFlag: this.userInfo.adminFlag,
                  selectCompanyCode: this.userInfo.companyCode,
                  parentProductStatus: 'ZT03',
                }"
                @input="selectProductHandler"
                placeholder="请选择商品"
              >
              </search-table>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="商品子类简码" prop="productDetailCode" label-width="120px">
              <search-table
                :value="dialogData.productDetailCode"
                searchType="goodsAllCategory"
                :isMultiple="true"
                :currentValue="dialogData.productDetailCode"
                :checkRowKeys="[dialogData.productDetailCode]"
                :extraData="{
                  productParentCode: dialogData.productParentCode,
                  parentProductStatus: 'ZT03',
                }"
                :disabled="!dialogData.productParentCode"
                @input="selectProductDetailHandler"
                placeholder="请选择子类"
              >
              </search-table>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="品目" prop="detailProductItems" label-width="120px">
              <el-input disabled v-model="dialogData.detailProductItems"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="规格" prop="detailProductModel" label-width="120px">
              <el-input disabled v-model="dialogData.detailProductModel"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="24">
          <el-col :span="4">
            <el-form-item label="货物总件数" prop="qty" label-width="120px">
              <input-number-ad
                v-model="dialogData.qty"
                :controls="false"
                :min="0"
                :max="99999999999"
                :precision="0"
                :clearable="true"
                class="inputWidth"
                maxlength="99999999999999"
              >
              </input-number-ad>
            </el-form-item>
          </el-col>
          <el-col :span="2">
            <el-select v-model="dialogData.qtyUnit" placeholder="件数单位">
              <el-option
                v-for="(item, index) in qtyUnitList"
                :key="index"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </el-col>
          <el-col :span="4">
            <el-form-item label="货物总毛重" prop="grossWeight" label-width="120px">
              <input-number-ad
                v-model="dialogData.grossWeight"
                :controls="false"
                :min="0"
                :max="99999999999"
                :precision="2"
                :clearable="true"
                class="inputWidth"
                maxlength="99999999999999"
              ></input-number-ad>
            </el-form-item>
          </el-col>
          <el-col :span="2">
            <el-form-item label="" prop="grossWeightUnit">
              <el-select v-model="dialogData.grossWeightUnit" placeholder="毛重单位">
                <el-option
                  v-for="(item, index) in grossWeightUnitList"
                  :key="index"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="4">
            <el-form-item label="货物总体积" prop="volume" label-width="120px">
              <input-number-ad
                v-model="dialogData.volume"
                :controls="false"
                :min="0"
                :max="99999999999"
                :precision="2"
                :clearable="true"
                class="inputWidth"
                maxlength="99999999999999"
              ></input-number-ad>
            </el-form-item>
          </el-col>
          <el-col :span="2">
            <el-select v-model="dialogData.volumeUnit" placeholder="体积单位">
              <el-option
                v-for="(item, index) in volumeUnitList"
                :key="index"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </el-col>
          <el-col :span="6">
            <el-form-item label="备注" prop="remarks" label-width="120px">
              <el-input v-model="dialogData.remarks"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <template #footer>
      <span class="dialog-footer">
        <el-button @click="cancelHandler" size="small">取消</el-button>
        <el-button type="primary" @click="confirmHandler" size="small">确认</el-button>
      </span>
    </template>
  </el-dialog>
</template>

<script>
  import IntermodalityCommonMixin from '@/pages/intermodality/common/mixins/IntermodalityCommonMixin';
  import inputNumberAd from '@/components/form-item/input-number-advance';

  export default {
    name: 'EditFreightDialog',
    mixins: [IntermodalityCommonMixin],
    components: { inputNumberAd },
    data() {
      return {
        dialogVisible: false,
        rules: {
          productParentName: [{ required: true, message: '请选择商品' }],
          // grossWeight: [{ required: true, message: '请输入毛重' }],
          // grossWeightUnit: [{ required: true, message: '请选择单位' }],
        },
        dialogData: {
          productParentCode: null,
          productDetailCode: null,
          productParentName: null,
          detailProductItems: null,
          detailProductModel: null,
          qty: 0,
          qtyUnit: null,
          grossWeight: null,
          grossWeightUnit: null,
          volume: null,
          volumeUnit: null,
          remarks: '',
          xid: null,
        },
        isEditModal: false,
      };
    },

    mounted() {},

    computed: {
      getTitle() {
        if (this.isEditModal) {
          return '编辑货物';
        } else {
          return '新建货物';
        }
      },
    },
    methods: {
      openModal(rowData = {}) {
        this.dialogVisible = true;
        if (Object.keys(rowData).length) {
          this.isEditModal = true;
          for (let key in this.dialogData) {
            this.dialogData[key] = rowData[key];
          }
          this.dialogData.xid = rowData._XID;
          console.log('dataId', this.dialogData.xid);
        } else {
          this.isEditModal = false;
          for (let key in this.dialogData) {
            this.dialogData[key] = null;
          }
        }
      },
      cancelHandler() {
        for (let key in this.dialogData) {
          this.dialogData[key] = null;
        }
        this.dialogVisible = false;
      },
      selectProductHandler(row) {
        this.dialogData.productParentName = row ? row[0].productChName : null;
        this.dialogData.productParentCode = row ? row[0].parentProductNo : null;
        console.log('product', row);

        this.dialogData.productDetailCode = null;
        this.dialogData.detailProductItems = null;
        this.dialogData.detailProductModel = null;
      },
      selectProductDetailHandler(row) {
        console.log('productDetail', row);
        this.dialogData.productDetailCode = row[0].productDetailCode ?? row[0].parentProductNo;
        this.dialogData.detailProductItems = row ? row[0].detailProductItems : null;
        this.dialogData.detailProductModel = row ? row[0].detailProductModel : null;
      },
      confirmHandler() {
        this.$refs.dialogForm.validate(async (valid) => {
          const data = { ...this.dialogData };
          if (valid) {
            this.$emit('confirmHandler', data, this.isEditModal);
            this.cancelHandler();
          }
        });
      },
    },
  };
</script>

<style lang="scss" scoped></style>
